import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { SchoolPackage } from 'bookraw/shared/models/school-package.model';
import { Observable } from 'rxjs';
import { ItemResponse } from 'bookraw/shared/models/api/item.response';
import { environment } from 'env/environment';
import { HttpHeaders } from '@angular/common/http';
import { ListResponse } from 'bookraw/shared/models/api/list.response';

@Injectable()
export class SchoolPackagesService extends ListService<SchoolPackage> {

  url: string = '/api/admin/schoolPackages';

  getListBySchool(schoolId: string, onlyActive?: boolean): Observable<ListResponse<SchoolPackage>> {
    const filters = onlyActive ? { 'filters[schoolId]': schoolId, 'filters[active]': '1' } : { 'filters[schoolId]': schoolId };
    return this.http.get<ListResponse<SchoolPackage>>(environment.baseURL + this.url, {
      params: filters
    });
  }

  getListByPartner(partnerId: string, onlyActive?: boolean): Observable<ListResponse<SchoolPackage>> {
    const filters = onlyActive ? { 'filters[partnerId]': partnerId, 'filters[active]': '1' } : { 'filters[partnerId]': partnerId };
    return this.http.get<ListResponse<SchoolPackage>>(environment.baseURL + this.url, {
      params: filters
    });
  }

  applySchoolPackage(schoolPackageId: number, userIds: number[]): Observable<ItemResponse<SchoolPackage>> {
    return this.http.put<ItemResponse<SchoolPackage>>(environment.baseURL + this.url + '/' + schoolPackageId + '/applyMany', {
      userIds: userIds
    });
  }

  terminateSchoolPackage(schoolPackageId: number): Observable<ItemResponse<SchoolPackage>> {
    return this.http.put<ItemResponse<SchoolPackage>>(environment.baseURL + this.url + '/' + schoolPackageId + '/terminate', null);
  }

  removeUserSubscription(schoolPackageIds: number[], userIds: number[]) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        schoolPackageIds: schoolPackageIds,
        userIds: userIds
      }
    };

    return this.http.delete(environment.baseURL + '/api/admin/subscriptions', options);
  }
}
